import { VideoStep } from '../../types/video';

/**
 * Helper function to get button configuration from a step
 */
export const getButtonConfig = (step: VideoStep) => {
  if (step.button) {
    return {
      position: step.button.position || { top: '50%', left: '50%' },
      size: step.button.size || '30%',
    };
  }
  
  return null;
};

/**
 * Helper function to get button tooltip configuration from a step
 */
export const getButtonTooltipConfig = (step: VideoStep) => {
  if (step.button?.tooltip?.text) {
    return {
      text: step.button.tooltip.text,
      placement: step.button.tooltip.placement || 'top',
      variant: step.button.tooltip.variant || 'black',
    };
  }
  
  return null;
};

/**
 * Helper function to get tooltip configuration from a step
 */
export const getTooltipConfig = (step: VideoStep) => {
  if (step.tooltip?.text) {
    return {
      text: step.tooltip.text,
      position: step.tooltip.position || { top: '50%', left: '50%' },
      variant: step.tooltip.variant || 'teal',
    };
  }
  
  return null;
};

/**
 * Helper function to check if a step has a button
 */
export const hasButton = (step: VideoStep): boolean => {
  return !!step.button;
};

/**
 * Helper function to check if a step has a tooltip
 */
export const hasTooltip = (step: VideoStep): boolean => {
  return !!step.tooltip?.text;
};

/**
 * Helper function to check if a step has a button tooltip
 */
export const hasButtonTooltip = (step: VideoStep): boolean => {
  return !!(step.button?.tooltip?.text);
}; 